import type { ReduxState } from '../types/internal/ReduxState';

export default ({ sendTypingIndicator }: ReduxState): boolean => sendTypingIndicator;
